import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { MessagingService } from "./../../services/messaging.service";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from "@angular/forms";
import { Observable } from "rxjs";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../global/global";
import * as CONSTANT from "src/app/services/constants";
import { HttpParams } from "@angular/common/http";
import { chatEnvironment } from "src/environments/chatEnvironment";

@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.css"]
})
export class MessageComponent implements OnInit {
  loginUser: any;
  allData: any;
  firebaseChats = chatEnvironment.chats;
  limit = 10;
  private allMsgListener: any;
  skip = 1;
  totalCount: any;
  modalScrollDistance = 2;
  modalScrollThrottle = 50;
  constructor(private route: ActivatedRoute, private router: Router, private db: AngularFireDatabase, private afAuth: AngularFireAuth, private messagingService: MessagingService, private formBuilder: FormBuilder, private storage: AngularFireStorage, private api: AdminService,) { }

  ngOnInit(): void {

    this.loginUser = localStorage.getItem("loginDetails");
    //this.chatId = "ID_" + this.loginUser.id;
    this.getJobs("");
  }

  getJobs(type) {
    let params = new HttpParams();
    params = params.append("skip", this.skip);
    params = params.append("limit", this.limit.toString());
    if (type === "1") {
      this.api.stopLoader();
    }
    this.api.getData(apiUrl._getActiveJobs, params)
      .subscribe(async (res) => {
        this.allData = res.data.listing
        this.totalCount = res.data.count;    
        for (let i = 0; i < this.allData.length; i++) {
          this.getJobDialogs(this.allData[i].id, i)
        }

      })
  }
  ngOnDestroy() {
    if (this.allMsgListener) {
      this.allMsgListener.unsubscribe();
    }
  }

  getJobDialogs(job_id, index) {
    this.allMsgListener = this.db.list(`${this.firebaseChats}`,
      query => query
        .orderByChild("job_id")
        .equalTo(job_id)
    ).valueChanges().subscribe(listNew => {
      let dialogListing = Object.assign([], listNew);
      if (dialogListing?.length > 0) {
        let msgCount = 0;
        let filterData = dialogListing.filter(data => {
            if (data['unread_count'][job_id] > 0) {
              console.log("job_id", data['unread_count'][job_id])
              console.log("job_id", data)
              msgCount = msgCount+ data['unread_count'][job_id]
            }
        });
        this.allData[index].unreadCount= msgCount
      }
    });
  
  }

  /** Infinite Scroll */
  onScrollDown() {
    console.log("scrolled down!!");
  }
  onModalScrollDown() {
    this.limit = this.totalCount;
    this.getJobs("1");
  }
}
